import { createDecorator } from '../../instantiation/common/instantiation.js';
const IThemeService = ( createDecorator('themeService'));
export { IThemeService };
